module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[20]507.27ffe2f.woff2";